import React, { Fragment } from "react";
import Header from "../Header/Header";
import PageTitle from "../pagetitle/PageTitle";
import Footer from "../footer/Footer";
import Scrollbar from "../scrollbar/scrollbar";
import LegalCheckIcon from "./LegalCheckIcon";
import { STATUTORY, identifierPairs } from "../../config/statutoryIdentifiers";

// Colorful theme background
import pricingBg from "../../images/bg/pricing-bg.png";
import cardBg from "../../images/bg/pricing-bg01.png";
import subLeftIcon from "../../images/icon/sub-left-icon.png";
import subRightIcon from "../../images/icon/sub-right-icon.png";

interface LegalPageLayoutProps {
  pageTitle: string;
  pageSub: string;
  lastUpdated: string;
  children: React.ReactNode;
}

const LegalPageLayout: React.FC<LegalPageLayoutProps> = ({
  pageTitle,
  pageSub,
  lastUpdated,
  children,
}) => {
  return (
    <Fragment>
      <div className="about-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle={pageTitle} pagesub={pageSub} />

            {/* Legal Section with Colorful Theme Background */}
            <section
              className="legal-section pos-rel pt-100 pb-120 bg_img"
              style={{ backgroundImage: `url(${pricingBg})` }}
            >
              <div className="container">
                {/* Section Title */}
                <div className="sec-title sec-title--two text-center mb-50">
                  <span className="sub-title mb-20">
                    <img src={subLeftIcon} alt="icon" /> Legal Document{" "}
                    <img src={subRightIcon} alt="icon" />
                  </span>
                  <h2 className="title">{pageTitle}</h2>
                </div>

                {/* Main Content Card with Glowing Background */}
                <div className="row justify-content-center">
                  <div className="col-lg-10">
                    <div
                      className="pricing-item xb-border bg_img"
                      style={{
                        backgroundImage: `url(${cardBg})`,
                        padding: '50px 40px',
                      }}
                    >
                      {/* Last Updated Notice */}
                      <div className="post_audio mb-30">
                        <div className="audio_play_btn xb-border">
                          <span>Last Updated: {lastUpdated}</span>
                        </div>
                      </div>

                      {/* Billing Notice */}
                      <div className="postabmin_block xb-border ul_li mb-40">
                        <div className="admin_content">
                          <p>
                            <strong>Note:</strong> All billing, invoices, and subscriptions for AXOIX
                            services are processed under <strong>Axoix Technologies Private Limited</strong>,
                            a registered business entity.
                          </p>
                          <p className="mt-10" style={{ fontSize: "13px", opacity: 0.85 }}>
                            {identifierPairs().map(([label, value], i) => (
                              <React.Fragment key={label}>
                                {i > 0 && <> &nbsp;|&nbsp; </>}
                                <strong>{label}:</strong> {value}
                              </React.Fragment>
                            ))}
                            <br />
                            <strong>Registered office:</strong> {STATUTORY.registeredOffice}
                          </p>
                        </div>
                      </div>

                      {/* Legal Content */}
                      <div className="legal-content">
                        {children}
                      </div>

                      {/* Contact Section */}
                      <div className="postabmin_block xb-border ul_li mt-60">
                        <div className="admin_content">
                          <h4 className="admin_name">Questions About This Policy?</h4>
                          <p>
                            If you have any questions about this policy, please contact us:
                          </p>
                          <ul className="pricing-list list-unstyled mt-20">
                            <li>
                              <span><LegalCheckIcon /></span>
                              <span>
                                <strong>Email:</strong>{" "}
                                <a href="mailto:rajat@axoix.com">rajat@axoix.com</a>
                              </span>
                            </li>
                            <li>
                              <span><LegalCheckIcon /></span>
                              <span>
                                <strong>Website:</strong>{" "}
                                <a href="https://axoix.com" target="_blank" rel="noopener noreferrer">
                                  axoix.com
                                </a>
                              </span>
                            </li>
                            <li>
                              <span><LegalCheckIcon /></span>
                              <span>
                                <strong>AXOIX Support:</strong>{" "}
                                <a href="mailto:hello@axoix.com">hello@axoix.com</a>
                              </span>
                            </li>
                            <li>
                              <span><LegalCheckIcon /></span>
                              <span>
                                <strong>Phone:</strong>{" "}
                                <a href="tel:+918929222212">+91 89292 22212</a>
                                {" "}(Mon–Sat, 10 AM – 7 PM IST)
                              </span>
                            </li>
                            {identifierPairs().map(([label, value]) => (
                              <li key={label}>
                                <span><LegalCheckIcon /></span>
                                <span>
                                  <strong>{label}:</strong> {value}
                                </span>
                              </li>
                            ))}
                            <li>
                              <span><LegalCheckIcon /></span>
                              <span>
                                <strong>Registered office:</strong> {STATUTORY.registeredOffice}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default LegalPageLayout;
